"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BY_PRODUCT = void 0;

var CRM = _interopRequireWildcard(require("./CRM"));

var MARKETING = _interopRequireWildcard(require("./Marketing"));

var SALES = _interopRequireWildcard(require("./Sales"));

var SERVICE = _interopRequireWildcard(require("./Service"));

var CMS = _interopRequireWildcard(require("./CMS"));

var BY_PRODUCT = {
  CRM: CRM,
  MARKETING: MARKETING,
  SALES: SALES,
  SERVICE: SERVICE,
  CMS: CMS
};
exports.BY_PRODUCT = BY_PRODUCT;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/hubspotFeatures/index.js
// module id = 366
// module chunks = 209 210 211 212